import React from "react";

import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";

export default function ProvidencesAutoComplete({
  params: params,
  disabled: disabled,
  options: options,
  label: label,
  width: width,
}) {
  // Destructure to prevent custom props from being passed to DOM
  const { value, onChange, error, errorLabel, isFieldValid, onCustomChange, ...autocompleteProps } = params;

  return (
    <Autocomplete
      disableClearable
      disabled={disabled}
      options={options}
      value={value}
      onChange={onChange}
      {...autocompleteProps}
      isOptionEqualToValue={(option, value) => {
        if (!value || value === "" || value.providenceName === "") {
          return true;
        }
        return option.providenceName === value.providenceName;
      }}
      getOptionLabel={(option) => {
        if (option === "") {
          return "";
        }
        return option.providenceName;
      }}
      renderOption={(props, option) => {
        const { key, ...otherProps } = props;
        return (
          <li key={option._id || option.id || option.providenceName} {...otherProps}>
            {option.providenceName}
          </li>
        );
      }}
      sx={{ width: width }}
      renderInput={(inputParams) => (
        <TextField 
          {...inputParams} 
          label={label} 
          required 
          error={error || undefined}
          helperText={error ? errorLabel : ""}
        />
      )}
    />
  );
}
